export default __webpack_public_path__ + "static/media/experiencem.ba91168f.png";